export const CENTURION = 'centurion';
export const GUEST = 'guest';
export const PLATINUM = 'platinum';
export const GOLD = 'gold';
